export default {
  common: {
    adminFunction: "Función de administrador",
    ecatLibrary: "e-CAT biblioteca",
    accountManagement: "Gestión de cuentas",
    accountPermission: "Gestión de cuentas y permisos",
    regionManagement: "Gestión de regiones",
    zoneCountryCity: "Actualizar zona, país y ciudad",
    cityWeatherManagement: "Datos del clima de la ciudad",
    weatherProfileBaseOnCity: "Actualizar perfil meteorológico basado en la ciudad",
    ecatDataManagement: "Gestión de datos de e-CAT",
    digitalEcatLibrary: "Biblioteca digital e-CAT",
    ecatLibraryEquipmentsModels: "Equipos y modelos de la biblioteca e-CAT",
    cancel: "Cancelar",
    save: "Guardar",
    permission: "Permiso",
    noAccountInfo: "No hay información de cuenta",

    customerFeedback: "Comentarios de los clientes",
    viewFeedbackList: "Mostrar información de comentarios de todos los clientes",

    unitSetting: "Configuración de unidad",
    globalUnitPreferences: "Preferencias de unidad global",

    usefulTools: "Herramientas útiles",
    efficiency: "Eficiencia"
  },
  account: {
    inputUserName: "Ingrese el correo electrónico",
    thereAreNoMoreUsersLeft: "No quedan más usuarios.",
    superAdmin: "Súper Administrador",
    global: "Global",
    region: "Región",
    regional: "Regional",
    zoneCountry: "Zona/País",
    city: "Ciudad",
    segmentMegaCity: "Segmento (Mega ciudad)",
    status: "Estado",
    activeStatus: "Active status",
    role: "Rol",
    active: "Activo",
    inactive: "Inactivo",
    fillRole: "Por favor, seleccione un rol",

    multiRegional: "Multi Regional",
    multiZoneCountry: "Multi país",
    singleZoneCountry: "única zona o país",

    otherRegions: "otras regiones",
    otherZones: "otras zonas"
  },
  feedback: {
    yourOpinionImportant: "Tu opinión es muy importante",
    tellYourExperience: "Por favor, díganos su experiencia de usuario",
    detailedFeedback: "Por favor introduzca su comentario:",
    provideDetailedYourOpinionssuggestions:
      "Por favor, proporcione una descripción detallada de sus opiniones y sugerencias, Puedes volver a abrir esta página desde [Mi espacio] -> [Mis comentarios].",
    submitFeedback: "Enviar comentarios",
    localAdministrator: "Apoyo local",
    ifProblemsContact: "Si encuentra problemas urgentes, por favor póngase en contacto con",
    noFeedback: "No hay comentarios",
    submissionSuccessful: "Presentación exitosa",
    myFeedback: "Mis comentarios",
    thereAreNoMoreFeedbackLeft: "No quedan más comentarios."
  },
  digitalEcat: {
    publicEcatLib: "Biblioteca e-CAT",
    myCustomized: "Biblioteca personalizada",
    chillerCapacity: "Capacidad del chiller",
    thereNoEcatLeft: "No quedan más datos de e-CAT",
    capacityRange: "Rango de capacidad",
    compressorType: "Tipo de compresor",
    refrigerantType: "Tipo de refrigerante",
    pleaseSelectOrEnter: "Buscar modelo o seleccionar criterios de filtro",
    clickHereToSelectAJsonFile: "Haga clic aquí para seleccionar un archivo JSON",
    successfullyParsed: "Modelos {modelsCount} analizados con éxito",
    bearingType: "Tipo de rodamiento",
    manufacturingRegion: "Región de fabricación",
    me: "yo",
    libraryOwner: "Propietario de la biblioteca",
    addSelfChillerModel: "Agregar modelo de chiller propio",
    capacity: "Capacidad",
    designCondenserTemp: "Temperatura de condensador de diseño",
    eCatPerformanceData: "Datos de rendimiento de e-CAT",
    point4Data: "Datos de 4 puntos",
    point10Data: "Datos de 10 puntos",
    computerPreview: "Vista previa de la curva de rendimiento",
    previewChilledWaterTemp: "Vista previa de la temperatura de suministro de agua refrigerada",
    previewCondenserTemp: "Vista previa de la temperatura del agua del condensador",
    previewCondenserAirTemp: "Vista previa de la temperatura del aire del condensador",
    compute: "Calcular",
    chillerType: "Tipo de chiller",
    youAreCurrentlyUsingLibrary: "Actualmente está utilizando la biblioteca '{selectUserEmail}' y no se le permite modificarla ni guardarla.",

    chillerModel: "Modelo de chiller",
    modelNumber: "Número de modelo",
    objective: "Objetivo",
    heatpumpType: "Tipo de bomba de calor",
    heatpumpFileParsed: "Archivo de bomba de calor procesado correctamente",
    chillerFileParsed: "Archivo de enfriadora procesado correctamente",

    previewSourceWaterTemp: "Vista previa de la temperatura de impulsión del agua de fuente",
    previewSourceAirTemp: "Vista previa de la temperatura del aire de fuente",
    previewHotWaterTemp: "Vista previa de la temperatura de impulsión del agua caliente",

    deviceType: "Tipo de equipo",
    addSelfHeatPumpModel: "Añadir un modelo propio de bomba de calor",
    heatPumpModel: "Modelo de bomba de calor",
    selectEquipmentType: "Seleccionar el tipo de equipo",
    createACustomChillerModel: "Crear un modelo personalizado de enfriadora",
    createACustomHeatPumpModel: "Crear un modelo personalizado de bomba de calor"
  },
  usefulTools: {
    asseesConfig: "Evalua los beneficios de actualizar los ventiladores de la unidad de distribución de aire a configuraciones de accionamiento directo.",
    clickEnter: "Haga clic para entrar",
    integratesTools: "Esta plataforma integra todas las herramientas de actualización y reacondicionamiento"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/es.js